import React, { useEffect, useState, useCallback } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { getContext } from "../Helpers/Context/Context";
import Footer from "../Layout/Footer/Footer";
// import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar/Sidebar";
import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import Login from "../Pages/Login/Login";
import "./router.css";
import Protected from "../Helpers/PageAccess/Protected";
import GridStructure from "../Components/GridStructure/GridStructure";
import Dashboard from "../Pages/Dashboard/Dashboard";
import UserRoleMappingDashboard from "../Pages/UserRoleMapping/UserRoleMappingDashboard";
import Header from "../Layout/Header/Header";
import MemberRegistration from "../Pages/MemberRegistration/MemberRegistration";
import ForgotPassword from "../Pages/ForgotPassword/ForgotPassword";
import RegistrationRequest from "../Pages/RegistrationRequest/RegistrationRequest";
import RegistrationApproval from "../Pages/RegistrationApproval/RegistrationApproval";
import UserRoleMapping from "../Pages/UserRoleMapping/UserRoleMapping";
import PaymentVerification from "../Pages/PaymentVerification/PaymentVerification";
import PaymentVerificationView from "../Pages/PaymentVerification/PaymentVerificationView";
import MemberVerification from "../Pages/MemberVerification/MemberVerification";
import MemberVerificationView from "../Pages/MemberVerification/MemberVerificationView";
import { useSelector } from "react-redux";
import UnitCodeMaster from "../Pages/Master/UnitCodeMaster/UnitCodeMaster";
import UnitCodeMasterEdit from "../Pages/Master/UnitCodeMaster/UnitCodeMasterEdit";
import CompanyMaster from "../Pages/Master/Company/CompanyMaster";
import CompanyMasterEdit from "../Pages/Master/Company/CompanyMasterEdit";
import SectorMaster from "../Pages/Master/Sector/SectorMaster";
import SectorMasterEdit from "../Pages/Master/Sector/SectorMasterEdit";
import LocationMaster from "../Pages/Master/Location/LocationMaster";
import LocationMasterEdit from "../Pages/Master/Location/LocationMasterEdit";
import LoanInterest from "../Pages/Master/LoanInterest/LoanInterest";
import LoanInterestEdit from "../Pages/Master/LoanInterest/LoanInterestEdit";
import LoanModule from "../Pages/LoanModule/LoanModule";
import LoanApprovalDashboard from "../Pages/LoanApproval/LoanApprovalDashboard";
import LoanDetailDashboard from "../Pages/LoanApproval/LoanDetailDashboard";
import LoanDashboard from "../Pages/LoanApplication/LoanDashboard";
import SuretyApproval from "../Pages/LoanModule/Surety/SuretyApproval";
import AgreementDetails from "../Pages/LoanApplication/AgreementDetails";
import MemberDashboard from "../Pages/MemberDashboard/MemberDashboard";
import BenefitSanjeevani from "../Pages/SanjeevaniYojna/BenefitSanjeevani";
import SanjeevaniForm from "../Pages/SanjeevaniYojna/SanjeevaniForm";
import SanjeevaniTransaction from "../Pages/SanjeevaniYojna/SanjeevaniTransaction";
import { RoleEnum } from "../Helpers/Enums/RoleEnum";
import SanjeevaniDashboard from "../Pages/SanjeevaniYojna/SanjeevaniDashboard";
import LoanDetailsMemberView from "../Pages/LoanApproval/View/LoanDetailsMemberView";
import DepositeStatementGrid from "../Pages/SanjeevaniYojna/DepositeStatementGrid";
import SanjeevaniTabs from "../Pages/MemberDashboard/SanjeevaniTabs";
import WithdrawStatmentGrid from "../Pages/SanjeevaniYojna/WithdrawStatmentGrid";
import SuretyMemberView from "../Pages/LoanModule/Surety/SuretyMemberView/SuretyMemberView";
import LoanDetailsMember_Repayment from "../Pages/LoanApproval/View/LoanDetailsMember_Repayment";
import LoanRepaymentDetails from "../Pages/LoanApproval/View/LoanRepaymentDetails";
import LoanSettlement from "../Pages/LoanApproval/View/LoanSettlement";
import PaymentDetails from "../Pages/LoanApproval/View/PaymentDetails";

import LoanSettlementDashboard from "../Pages/LoanApproval/View/LoanSettlementDashboard";
import LoanSettlementTabs from "../Pages/LoanApproval/View/LoanSettlementTabs";
import { AppModules } from "../Helpers/Enums/AppModules";
import SubscriptionPlanView from "../Pages/MemberDashboard/SubscriptionPlanView";
import FinalSettlement from "../Pages/LoanApproval/FinalSettlement";
import InnerSettlementRequest from "../Pages/InternalTeamSettlementRequest/InnerSettlementRequest";
import SettlementRequestDashboard from "../Pages/StatmentReqTabs/SettlementRequestDashboard";
import StlmtPersonalDetails from "../Pages/InternalTeamSettlementRequest/StlmtPersonalDetails";
import SettlmentRequestTabs from "../Pages/InternalTeamSettlementRequest/SettlmentRequestTabs";
import { getDefaultDashboard } from "../Helpers/Common";
import StlmtLoanDetails from "../Pages/InternalTeamSettlementRequest/StlmtLoanDetails";
import DemandRecoveryDashboard from "../Pages/DemandRecoveryTabs/DemandRecoveryDashboard";
import DemandRecoveryForm from "../Pages/DemandRecoveryTabs/DemandRecoveryForm";
import YearlyActivitiesDashboard from "../Pages/YearlyActivities/YearlyActivitiesDashboard";
import MonthlyCommonDashboard from "../Pages/Reports/MonthlyActivities/MonthlyCommonDashboard/MonthlyCommonDashboard";
import SettledMemberRegister from "../Pages/Reports/MonthlyActivities/AllMonthlyReports/SettledMemberRegister";
// import InnerSettlementRequest from "../Pages/InternalTeamSettlementRequest/InnerSettlementRequest";

import NewMemberRegister from "../Pages/Reports/MonthlyActivities/AllMonthlyReports/NewMemberRegister";
import MemberTableReco from "../Pages/Reports/MonthlyActivities/AllMonthlyReports/MemberTableReco";
import SuretyRegister from "../Pages/Reports/MonthlyActivities/AllMonthlyReports/SuretyRegister";
import LoanRegister from "../Pages/Reports/MonthlyActivities/AllMonthlyReports/LoanRegister";
import LoanPaidInExcess from "../Pages/Reports/MonthlyActivities/AllMonthlyReports/LoanPaidInExcess";
import ShortRecoveryReport from "../Pages/Reports/MonthlyActivities/AllMonthlyReports/ShortRecoveryReport";
import DividentCalculationReport from "../Pages/Reports/YearlyActivities/AllYearlyReports/DividentCalculationReport";
import DividentNEFTFileReport from "../Pages/Reports/YearlyActivities/AllYearlyReports/DividentNEFTFileReport";
import HDFCToHDFCReport from "../Pages/Reports/YearlyActivities/AllYearlyReports/HDFCToHDFCReport";
import ShareRegisterReport from "../Pages/Reports/YearlyActivities/AllYearlyReports/ShareRegisterReport";
import DividendWarrantPrintReport from "../Pages/Reports/YearlyActivities/AllYearlyReports/DividendWarrantPrintReport";
import DownloadDoc from "../Pages/DownloadDoc/DownloadDoc";

export const AllRoutes = {
  root: { link: "/", title: "", pname: "" },
  login: { link: "/login", title: "", pname: "" },
  ForgotPassword: { link: "/ForgotPassword", title: "", pname: "" },
  AccessDenied: {
    link: "/AccessDenied",
    title: "",
    pname: "",
  },
  Dashboard: {
    link: "/Dashboard",
    title: "Dashboard",
    pname: "Dashboard",
  },
  LoanDetails: {
    link: "/LoanDetails",
    title: "Loan Details",
    pname: "LoanDetails",
  },
  SuretyApproval: {
    link: "/SuretyApproval",
    title: "Surety Approval",
    pname: "SuretyApproval",
  },
  SuretyMemberView: {
    link: "/SuretyMemberView",
    title: "Surety Details",
    pname: "SuretyMemberView",
  },
  UserRoleMapping: {
    link: "/master/UserRoleMapping",
    title: "User Role Mapping",
    pname: "UserRoleMappingDashboard",
  },
  UserRoleMappingEdit: {
    link: "/master/UserRoleMapping/edit",
    title: "User Role Mapping",
    pname: "UserRoleMapping",
  },
  UnitCodeMaster: {
    link: "/master/UnitCodeMaster",
    title: "Unit Code",
    pname: "UnitCodeMaster",
  },
  UnitCodeMasterEdit: {
    link: "/master/UnitCodeMaster/edit",
    title: "Unit Code",
    pname: "UnitCodeMasterEdit",
  },
  CompanyMaster: {
    link: "/master/CompanyMaster",
    title: "Company",
    pname: "CompanyMaster",
  },
  CompanyMasterEdit: {
    link: "/master/CompanyMaster/edit",
    title: "Company",
    pname: "CompanyMasterEdit",
  },
  SectorMaster: {
    link: "/master/SectorMaster",
    title: "Sector",
    pname: "SectorMaster",
  },
  SectorMasterEdit: {
    link: "/master/SectorMaster/edit",
    title: "Sector",
    pname: "SectorMasterEdit",
  },
  LocationMaster: {
    link: "/master/LocationMaster",
    title: "Location",
    pname: "LocationMaster",
  },
  LocationMasterEdit: {
    link: "/master/LocationMaster/edit",
    title: "Location",
    pname: "LocationMasterEdit",
  },
  LoanInterest: {
    link: "/master/LoanInterest",
    title: "Loan Interest",
    pname: "LoanInterest",
  },
  LoanInterestEdit: {
    link: "/master/LoanInterest/edit",
    title: "Loan Interest",
    pname: "LoanInterestEdit",
  },
  MemberRegistrationForm: {
    link: "/MemberRegistrationForm",
    title: "Member Registration",
    pname: "MemberRegistration",
  },
  RegistrationRequest: {
    link: "/RegistrationRequest",
    title: "Registration Requests",
    pname: "RegistrationRequest",
  },
  RegistrationApproval: {
    link: "/RegistrationApproval",
    title: "Registration Approval",
    pname: "RegistrationApproval",
  },
  PaymentVerification: {
    link: "/PaymentVerification",
    title: "Payment Verification",
    pname: "PaymentVerification",
  },
  PaymentVerificationView: {
    link: "/PaymentVerificationView",
    title: "Payment Verification",
    pname: "PaymentVerificationView",
  },
  MemberVerification: {
    link: "/MemberVerification",
    title: "Member Request",
    pname: "MemberVerification",
  },
  MemberVerificationView: {
    link: "/MemberVerificationView",
    title: "Member Request",
    pname: "MemberVerificationView",
  },
  LoanModule: {
    link: "/LoanModule",
    title: "Loan Module",
    pname: "LoanModule",
  },
  LoanDashboard: {
    link: "/LoanDashboard",
    title: "Loan Dashboard",
    pname: "LoanDashboard",
  },
  LoanApprovalDashboard: {
    link: "/LoanApprovalDashboard",
    title: "Loan Approval Dashboard",
    pname: "LoanApprovalDashboard",
  },
  LoanSettlementDashboard: {
    link: "/LoanSettlementDashboard",
    title: "Loan Settlement Dashboard",
    pname: "LoanSettlementDashboard",
  },
  LoanDetailDashboard: {
    link: "/LoanDetailDashboard",
    title: "Loan Detail Dashboard",
    pname: "LoanDetailDashboard",
  },
  LoanDetailsMemberView: {
    link: "/LoanDetailsMemberView",
    title: "Loan Details",
    pname: "LoanDetailsMemberView",
  },
  LoanDetailsMember_Repayment: {
    link: "/LoanRepaymentDetails",
    title: "Loan Repayment Details",
    pname: "LoanRepaymentDetails",
  },
  // Sanjeevani start
  MemberDashboard: {
    link: "/MemberDashboard",
    title: "Member Dashboard",
    pname: "MemberDashboard",
  },
  SanjeevaniYojana: {
    link: "/SanjivaniYojana",
    title: "SANJIVANI YOJNA",
    pname: "SanjeevaniYojana",
  },
  SanjeevaniForm: {
    link: "/SanjivaniForm",
    title: "SANJIVANI YOJNA",
    pname: "SanjeevaniForm",
  },
  SanjeevaniTabs: {
    link: "/SanjivaniMenu",
    title: "SANJIVANI YOJNA",
    pname: "SanjeevaniTabs",
  },
  SanjeevaniTransaction: {
    link: "/SanjivaniTransaction",
    title: "SANJIVANI YOJNA",
    pname: "SanjeevaniTransaction",
  },
  SanjeevaniDashboard: {
    link: "/SanjivaniDashboard",
    title: "Sanjivani-Dashboard",
    pname: "SanjeevaniDashboard",
  },
  // Suvidha started
  SuvidhaMemberDashboard: {
    link: "/MemberDashboard",
    title: "Member Dashboard",
    pname: "SuvidhaMemberDashboard",
  },
  SuvidhaYojana: {
    link: "/SuvidhaYojana",
    title: "Suvidha YOJNA",
    pname: "SuvidhaYojana",
  },
  SuvidhaForm: {
    link: "/SuvidhaForm",
    title: "Suvidha YOJNA",
    pname: "SuvidhaForm",
  },
  SuvidhaTransaction: {
    link: "/SuvidhaTransaction",
    title: "Suvidha YOJNA",
    pname: "SuvidhaTransaction",
  },
  SuvidhaTabs: {
    link: "/SuvidhaMenu",
    title: "Suvidha YOJNA",
    pname: "SuvidhaTabs",
  },
  SuvidhaDashboard: {
    link: "/SuvidhaDashboard",
    title: "Suvidha-Dashboard",
    pname: "SuvidhaDashboard",
  },
  SettlementRequest: {
    link: "/SettlementRequestDashboard",
    // title: "Statment Request Dashboard",
    title: "Settlement Request Dashboard",
    pname: "SettlementRequest",
  },
  FinalSettlement: {
    link: "/FinalSettlement",
    title: "Final Settlement",
    pname: "FinalSettlement",
  },
  SettlementRequestTabs: {
    link: "/SettlementRequestTabs",
    title: "Settlement Request Tabs",
    pname: "SettlementRequestTabs",
  },
  DemandRecoveryDashboard: {
    link: "/DemandRecovery",
    title: "Demand Recovery Dashboard",
    pname: "DemandRecoveryDashboard",
  },
  LoanSettlementTabs: {
    link: "/LoanSettlementTabs",
    title: "Loan Repayment",
    pname: "LoanSettlementTabs",
  },
  SubscriptionPlanView: {
    link: "/SubscriptionPlanView",
    title: "Subscription Plan Details",
    pname: "SubscriptionPlanView",
  },
  YearlyActivitiesDashboard: {
    link: "/YearlyDividentDashboard",
    title: "Yearly Divident Dashboard",
    pname: "YearlyActivitiesDashboard",
  },
  InnerSettlementRequest: {
    link: "/InnerSettlementRequest",
    title: " ",
    pname: "InnerSettlementRequest",
  },
  // Report
  NewMemberRegister: {
    link: "/NewMemberRegister",
    title: "New Member Register",
    pname: "NewMemberRegister",
  },
  SettledMemberRegister: {
    link: "/SettledMemberRegister",
    title: "Settled Member Register",
    pname: "SettledMemberRegister",
  },
  SuretyRegister: {
    link: "/SuretyRegister",
    title: "Surety Register",
    pname: "SuretyRegister",
  },
  LoanRegister: {
    link: "/LoanRegister",
    title: "Loan Register",
    pname: "LoanRegister",
  },
  LoanPaidInExcess: {
    link: "/LoanPaidInExcess",
    title: "Loan Paid In Excess",
    pname: "LoanPaidInExcess",
  },
  MemberTableReco: {
    link: "/MemberTableReco",
    title: "Member Table Reco Vs. FI Entries",
    pname: "MemberTableReco",
  },
  ShortRecoveryReport: {
    link: "/ShortRecoveryReport",
    title: "Short Recovery Report",
    pname: "ShortRecoveryReport",
  },
  DividentCalculationReport: {
    link: "/DividentCalculationReport",
    title: "Dividend Calculation",
    pname: "DividentCalculationReport",
  },
  DividentNEFTFileReport: {
    link: "/DividentNEFTFileReport",
    title: "Dividend NEFT File",
    pname: "DividentNEFTFileReport",
  },
  HDFCToHDFCReport: {
    link: "/HDFCToHDFCReport",
    title: "HDFC To HDFC",
    pname: "HDFCToHDFCReport",
  },
  DividendWarrantPrintReport: {
    link: "/DividendWarrantPrintReport",
    title: "Dividend Warrant Print",
    pname: "DividendWarrantPrintReport",
  },
  ShareRegisterReport: {
    link: "/ShareRegisterReport",
    title: "Share Register",
    pname: "ShareRegisterReport",
  },

  DownloadDoc: {
    link: "/DownloadDoc",
    title: "Download Document",
    pname: "DownloadDoc",
  },
};

const Router = () => {
  const location = useLocation();
  // let context = getContext();
  const context = useSelector((state: any) => state.updateReduxStore);
  let navigate = useNavigate();
  // console.log("Router Context: ", context);
  const [asidebar, setAsidebar] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [headerArr] = useState<Array<String>>([
    AllRoutes.login.link,
    AllRoutes.ForgotPassword.link,
  ]);
  const openRoutes: Array<string> = [
    AllRoutes.login.link,
    AllRoutes.ForgotPassword.link,
    AllRoutes.MemberRegistrationForm.link,
  ];
  const secret = "secret";

  const mobileResMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const getRouteTitle = () => {
    let title = "";
    const route = Object.entries(AllRoutes)?.find(
      (ar) => ar?.[1]?.link?.toLowerCase() === location?.pathname?.toLowerCase()
    );
    title = route?.[1]?.title;
    if (
      route?.[1]?.pname === "LoanApprovalDashboard" &&
      context?.CurrentRoleId === RoleEnum.Member
    ) {
      title = "Loan Dashboard";
    }

    return title;
  };

  const routeTitle = getRouteTitle();

  const isUserLogedIn = useCallback((): boolean => {
    let isLogedIn = true;
    if (!context || !context?.Id) {
      if (
        !openRoutes.find(
          (or) => or?.toLowerCase() === location?.pathname?.toLowerCase()
        )
      ) {
        isLogedIn = false;
      }
    }
    return isLogedIn;
  }, [context, location?.pathname, openRoutes]);

  useEffect(() => {
    if (!isUserLogedIn()) {
      if (location.search) {
        const params = new URLSearchParams(location.search);
        const keys = ["memberid", "suretyid", "docid"];

        for (const key of keys) {
          if (params.has(key)) {
            navigate(`${AllRoutes.login.link}?${key}=${params.get(key)}`);
            break;
          }
        }
        // const params = new URLSearchParams(location.search);
        // if (params.has("memberid")) {
        //   navigate(
        //     AllRoutes.login.link + "?memberid=" + params.get("memberid")
        //   );
        // } else if (params.has("suretyid")) {
        //   // && location.pathname?.toLowerCase() !== AllRoutes.SuretyApproval.link?.toLowerCase()) {
        //   navigate(
        //     AllRoutes.login.link + "?suretyid=" + params.get("suretyid")
        //   );
        // }else if (params.has("docid")){
        //   navigate(
        //     AllRoutes.login.link + "?docid=" + params.get("docid")
        //   );
        // }
      } else {
        navigate(AllRoutes.login.link);
      }
    }
  }, [isUserLogedIn, navigate]);

  if (!isUserLogedIn()) {
    return null;
  }

  // const [linkFound, setLinkFound] = useState(false);

  // for (const route in AllRoutes) {
  //   if (
  //     AllRoutes.hasOwnProperty(route) &&
  //     AllRoutes[route].link.toLocaleLowerCase() ===
  //       window.location.pathname.toLocaleLowerCase()
  //   ) {
  //     setLinkFound(true);
  //     break;
  //   }
  // }

  return (
    <div className="menubar-hoverable header-fixed">
      {(!headerArr.includes(window.location.pathname) && context) ||
      window.location.pathname === AllRoutes.MemberRegistrationForm.link ? (
        // <Header
        //   menuOpenFunc={mobileResMenu}
        //   setAsidebar={setAsidebar}
        //   aisebar={asidebar}
        // />
        <Header menuOpenFunc={mobileResMenu} />
      ) : null}
      {headerArr.includes(window.location.pathname) ? (
        <Routes>
          <Route path={AllRoutes.login.link} element={<Login />} />
          <Route
            path={AllRoutes.ForgotPassword.link}
            element={<ForgotPassword />}
          />
        </Routes>
      ) : (
        <>
          <div
            id="base"
            className={
              window?.location?.pathname?.toLowerCase() ===
              AllRoutes?.MemberRegistrationForm?.link?.toLowerCase()
                ? "MemberRegistrationBase"
                : ""
            }
          >
            <div id="content">
              <div className="main-content">
                <div className="route-title-container">
                  <span className="route-title">{routeTitle}</span>
                </div>
                <div className="inner-content">
                  <Routes>
                    {!context ? (
                      <Route
                        path={AllRoutes.root.link}
                        element={<Navigate to={AllRoutes.login.link} replace />}
                      />
                    ) : (
                      <Route
                        path={AllRoutes.root.link}
                        element={
                          <Navigate
                            to={getDefaultDashboard(context?.CurrentRoleId)}
                            replace
                          />
                        }
                      />
                    )}
                    <Route
                      path={AllRoutes.AccessDenied.link}
                      element={<AccessDenied />}
                    />
                    <Route
                      path={AllRoutes.Dashboard.link}
                      element={
                        <Protected
                          permittedPages={"Dashboard"}
                          pageContext={context}
                        >
                          <Dashboard />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.UserRoleMapping.link}`}
                      element={
                        <Protected
                          permittedPages={"UserRoleMappingDashboard"}
                          pageContext={context}
                        >
                          <UserRoleMappingDashboard />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.UserRoleMappingEdit.link}`}
                      element={
                        <Protected
                          permittedPages={"UserRoleMapping"}
                          pageContext={context}
                        >
                          <UserRoleMapping />
                        </Protected>
                      }
                      // element={<UserRoleMapping />}
                    />
                    <Route
                      path={`${AllRoutes.UnitCodeMaster.link}`}
                      element={
                        <Protected
                          permittedPages={"UnitCodeMaster"}
                          pageContext={context}
                        >
                          <UnitCodeMaster />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.UnitCodeMasterEdit.link}`}
                      element={
                        <Protected
                          permittedPages={"UnitCodeMasterEdit"}
                          pageContext={context}
                        >
                          <UnitCodeMasterEdit />
                        </Protected>
                      }
                      // element={<UserRoleMapping />}
                    />
                    <Route
                      path={`${AllRoutes.CompanyMaster.link}`}
                      element={
                        <Protected
                          permittedPages={"CompanyMaster"}
                          pageContext={context}
                        >
                          <CompanyMaster />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.CompanyMasterEdit.link}`}
                      element={
                        <Protected
                          permittedPages={"CompanyMasterEdit"}
                          pageContext={context}
                        >
                          <CompanyMasterEdit />
                        </Protected>
                      }
                      // element={<UserRoleMapping />}
                    />
                    <Route
                      path={`${AllRoutes.SectorMaster.link}`}
                      element={
                        <Protected
                          permittedPages={"SectorMaster"}
                          pageContext={context}
                        >
                          <SectorMaster />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.SectorMasterEdit.link}`}
                      element={
                        <Protected
                          permittedPages={"SectorMasterEdit"}
                          pageContext={context}
                        >
                          <SectorMasterEdit />
                        </Protected>
                      }
                      // element={<UserRoleMapping />}
                    />
                    <Route
                      path={`${AllRoutes.LocationMaster.link}`}
                      element={
                        <Protected
                          permittedPages={"LocationMaster"}
                          pageContext={context}
                        >
                          <LocationMaster />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.LocationMasterEdit.link}`}
                      element={
                        <Protected
                          permittedPages={"LocationMasterEdit"}
                          pageContext={context}
                        >
                          <LocationMasterEdit />
                        </Protected>
                      }
                      // element={<UserRoleMapping />}
                    />
                    <Route
                      path={`${AllRoutes.LoanInterest.link}`}
                      element={
                        <Protected
                          permittedPages={"LoanInterest"}
                          pageContext={context}
                        >
                          <LoanInterest />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.LoanInterestEdit.link}`}
                      element={
                        <Protected
                          permittedPages={"LoanInterestEdit"}
                          pageContext={context}
                        >
                          <LoanInterestEdit />
                        </Protected>
                      }
                      // element={<UserRoleMapping />}
                    />
                    <Route
                      path={AllRoutes.MemberRegistrationForm.link}
                      element={
                        // <Protected
                        //   permittedPages={"MemberRegistration"}
                        //   pageContext={context}
                        // >
                        <MemberRegistration />
                        // </Protected>
                      }
                      // element={<MemberRegistration />}
                    />
                    <Route
                      path={AllRoutes.RegistrationRequest.link}
                      // element={<RegistrationRequest />}
                      element={
                        <Protected
                          permittedPages={"RegistrationRequest"}
                          pageContext={context}
                        >
                          <RegistrationRequest />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.RegistrationApproval.link}
                      element={
                        <Protected
                          permittedPages={"RegistrationApproval"}
                          pageContext={context}
                        >
                          <RegistrationApproval />
                        </Protected>
                      }
                      // element={<RegistrationApproval />}
                    />
                    <Route
                      path={AllRoutes.PaymentVerification.link}
                      element={
                        <Protected
                          permittedPages={"PaymentVerification"}
                          pageContext={context}
                        >
                          <PaymentVerification />
                        </Protected>
                      }
                      // element={<PaymentVerification />}
                    />
                    <Route
                      path={AllRoutes.PaymentVerificationView.link}
                      element={
                        <Protected
                          permittedPages={"PaymentVerificationView"}
                          pageContext={context}
                        >
                          <PaymentVerificationView />
                        </Protected>
                      }
                      // element={<PaymentVerificationView />}
                    />
                    <Route
                      path={AllRoutes.MemberVerification.link}
                      element={
                        <Protected
                          permittedPages={"MemberVerification"}
                          pageContext={context}
                        >
                          <MemberVerification />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.MemberVerificationView.link}
                      element={
                        <Protected
                          permittedPages={"MemberVerificationView"}
                          pageContext={context}
                        >
                          <MemberVerificationView />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.LoanModule.link}
                      element={
                        // <Protected
                        //   permittedPages={"LoanModule"}
                        //   pageContext={context}
                        // >
                        <LoanModule />
                        // </Protected>
                      }
                      // element={<PaymentVerificationView />}
                    />
                    <Route
                      path={AllRoutes.LoanDashboard.link}
                      element={
                        // <Protected
                        //   permittedPages={"LoanModule"}
                        //   pageContext={context}
                        // >
                        <LoanDashboard />
                        // </Protected>
                      }
                      // element={<PaymentVerificationView />}
                    />
                    <Route
                      path={AllRoutes.LoanDashboard.link}
                      element={
                        <Protected
                          permittedPages={"LoanModule"}
                          pageContext={context}
                        >
                          <LoanDashboard />
                        </Protected>
                      }
                      // element={<PaymentVerificationView />}
                    />
                    <Route
                      path={AllRoutes.LoanDetailsMemberView.link}
                      element={
                        <Protected
                          permittedPages={"LoanDetailsMemberView"}
                          pageContext={context}
                        >
                          <LoanDetailsMemberView />
                        </Protected>
                      }
                      // element={<PaymentVerificationView />}
                    />
                    <Route
                      path={AllRoutes.LoanApprovalDashboard.link}
                      element={
                        <Protected
                          permittedPages={"LoanApprovalDashboard"}
                          pageContext={context}
                        >
                          <LoanApprovalDashboard />
                        </Protected>
                      }
                    />
                    {/* --------------------- Sanjeevani Start --------------------- */}
                    <Route
                      path={`${AllRoutes.MemberDashboard.link}`}
                      element={
                        <Protected
                          permittedPages={"MemberDashboard"}
                          pageContext={context}
                        >
                          <MemberDashboard
                            appModule={AppModules.SanjeevaniYojana}
                          />
                        </Protected>
                      }
                    />
                    {/* <Route
                      path={`${AllRoutes.SanjeevaniYojana.link}`}
                      element={
                        <Protected
                          permittedPages={"SanjeevaniYojana"}
                          pageContext={context}
                        >
                          <SanjeevaniTabs
                            appModule={AppModules.SanjeevaniYojana}
                          />
                        </Protected>
                      }
                    /> */}
                    <Route
                      path={`${AllRoutes.SanjeevaniYojana.link}`}
                      element={
                        <Protected
                          permittedPages={"SanjeevaniYojana"}
                          pageContext={context}
                        >
                          <BenefitSanjeevani
                            appModule={AppModules.SanjeevaniYojana}
                          />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.SanjeevaniTabs.link}`}
                      element={
                        <Protected
                          permittedPages={"SanjeevaniTabs"}
                          pageContext={context}
                        >
                          <SanjeevaniTabs
                            appModule={AppModules.SanjeevaniYojana}
                          />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.SanjeevaniDashboard.link}`}
                      element={
                        <Protected
                          permittedPages={"SanjeevaniDashboard"}
                          pageContext={context}
                        >
                          <SanjeevaniDashboard
                            appModule={AppModules.SanjeevaniYojana}
                          />
                        </Protected>
                      }
                    />
                    {/* <Route
                      path="/SanjeevaniDashboard"
                      element={<SanjeevaniDashboard />}
                    /> */}
                    <Route
                      path="/WithdrawStatmentGrid"
                      element={<WithdrawStatmentGrid />}
                    />
                    <Route
                      path={`${AllRoutes.SanjeevaniForm.link}`}
                      element={
                        <Protected
                          permittedPages={"SanjeevaniForm"}
                          pageContext={context}
                        >
                          <SanjeevaniForm
                            appModule={AppModules.SanjeevaniYojana}
                          />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.SanjeevaniTransaction.link}`}
                      element={
                        <Protected
                          permittedPages={"SanjeevaniTransaction"}
                          pageContext={context}
                        >
                          <SanjeevaniTransaction
                            appModule={AppModules.SanjeevaniYojana}
                          />
                        </Protected>
                      }
                    />
                    {/*------------ Suvidha Start -----------------*/}
                    <Route
                      path={`${AllRoutes.SuvidhaDashboard.link}`}
                      element={
                        <Protected
                          permittedPages={"SuvidhaDashboard"}
                          pageContext={context}
                        >
                          <SanjeevaniDashboard
                            appModule={AppModules.SuvidhaYojna}
                          />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.SuvidhaTabs.link}`}
                      element={
                        <Protected
                          permittedPages={"SuvidhaTabs"}
                          pageContext={context}
                        >
                          <SanjeevaniTabs appModule={AppModules.SuvidhaYojna} />
                        </Protected>
                      }
                    />
                    {/* <Route path="/SuvidhaMenu" element={<SanjeevaniTabs />} /> */}
                    <Route
                      path={`${AllRoutes.SuvidhaYojana.link}`}
                      element={
                        <Protected
                          permittedPages={"SuvidhaYojana"}
                          pageContext={context}
                        >
                          <BenefitSanjeevani
                            appModule={AppModules.SuvidhaYojna}
                          />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.SuvidhaForm.link}`}
                      element={
                        <Protected
                          permittedPages={"SuvidhaForm"}
                          pageContext={context}
                        >
                          <SanjeevaniForm appModule={AppModules.SuvidhaYojna} />
                        </Protected>
                      }
                    />
                    <Route
                      path={`${AllRoutes.SuvidhaTransaction.link}`}
                      element={
                        <Protected
                          permittedPages={"SuvidhaTransaction"}
                          pageContext={context}
                        >
                          <SanjeevaniTransaction
                            appModule={AppModules.SuvidhaYojna}
                          />
                        </Protected>
                      }
                    />

                    <Route
                      path={`${AllRoutes.YearlyActivitiesDashboard.link}`}
                      element={
                        <Protected
                          permittedPages={"YearlyActivitiesDashboard"}
                          pageContext={context}
                        >
                          <YearlyActivitiesDashboard />
                        </Protected>
                      }
                    />
                    {/* <Route
                      path="/YearlyActivitiesDashboard"
                      element={<YearlyActivitiesDashboard />}
                    /> */}
                    {/* <Route
                      path="/SuvidhaTransaction"
                      element={
                        <SanjeevaniTransaction
                          appModule={AppModules.SuvidhaYojna}
                        />
                      }
                    /> */}
                    {/*--------------Suviadha Ends----------- */}
                    {/* InnerSettlementRequest */}
                    {/* <Route
                      path="/InnerSettlementRequest"
                      element={<InnerSettlementRequest />}
                    /> */}
                    <Route
                      path={AllRoutes.InnerSettlementRequest.link}
                      element={
                        <Protected
                          permittedPages={"InnerSettlementRequest"}
                          pageContext={context}
                        >
                          <InnerSettlementRequest />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.SuretyApproval.link}
                      element={
                        <Protected
                          permittedPages={"SuretyApproval"}
                          pageContext={context}
                        >
                          <SuretyApproval />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.DownloadDoc.link}
                      element={
                        <Protected
                          permittedPages={"DownloadDoc"}
                          pageContext={context}
                        >
                          <DownloadDoc />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.SuretyMemberView.link}
                      element={
                        <Protected
                          permittedPages={"SuretyMemberView"}
                          pageContext={context}
                        >
                          <SuretyMemberView />
                        </Protected>
                      }
                    />
                    {/* SubscriptionPlanView */}
                    {/* <Route
                      path={AllRoutes.SubscriptionPlanView.link}
                      element={
                        <Protected
                          permittedPages={"SubscriptionPlanView"}
                          pageContext={context}
                        >
                          <SubscriptionPlanView />
                        </Protected>
                      }
                    /> */}
                    <Route
                      path="/SubscriptionPlanView"
                      element={<SubscriptionPlanView />}
                    />
                    <Route
                      path={"/LoanDetailDashboard"}
                      element={<LoanDetailDashboard />}
                    />
                    <Route
                      path="/LoanDetailsMemberRepayment"
                      element={<LoanDetailsMember_Repayment />}
                    />
                    <Route
                      path="/LoanSettlement"
                      element={<LoanSettlement />}
                    />
                    {/* <Route path="/LoanRepaymentDetails" element={<LoanRepaymentDetails />} /> */}
                    <Route
                      path={`${AllRoutes.LoanDetailsMember_Repayment.link}`}
                      // element={
                      //     <LoanRepaymentDetails />

                      // }
                      // permittedPages={"LoanRepaymentDetails"}
                      element={
                        // <Protected pageContext={context}>
                        <LoanRepaymentDetails />
                        // </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.SettlementRequest.link}
                      element={
                        <Protected
                          permittedPages={"SettlementRequest"}
                          pageContext={context}
                        >
                          <SettlementRequestDashboard />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.SettledMemberRegister.link}
                      element={
                        <Protected
                          permittedPages={"SettledMemberRegister"}
                          pageContext={context}
                        >
                          <SettledMemberRegister />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.MemberTableReco.link}
                      element={
                        <Protected
                          permittedPages={"MemberTableReco"}
                          pageContext={context}
                        >
                          <MemberTableReco />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.NewMemberRegister.link}
                      element={
                        <Protected
                          permittedPages={"NewMemberRegister"}
                          pageContext={context}
                        >
                          <NewMemberRegister />
                        </Protected>
                      }
                    />

                    <Route
                      path={AllRoutes.SuretyRegister.link}
                      element={
                        <Protected
                          permittedPages={"SuretyRegister"}
                          pageContext={context}
                        >
                          <SuretyRegister />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.LoanRegister.link}
                      element={
                        <Protected
                          permittedPages={"LoanRegister"}
                          pageContext={context}
                        >
                          <LoanRegister />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.LoanPaidInExcess.link}
                      element={
                        <Protected
                          permittedPages={"LoanPaidInExcess"}
                          pageContext={context}
                        >
                          <LoanPaidInExcess />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.ShortRecoveryReport.link}
                      element={
                        <Protected
                          permittedPages={"ShortRecoveryReport"}
                          pageContext={context}
                        >
                          <ShortRecoveryReport />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.DividendWarrantPrintReport.link}
                      element={
                        <Protected
                          permittedPages={"DividendWarrantPrintReport"}
                          pageContext={context}
                        >
                          <DividendWarrantPrintReport />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.DividentCalculationReport.link}
                      element={
                        <Protected
                          permittedPages={"DividentCalculationReport"}
                          pageContext={context}
                        >
                          <DividentCalculationReport />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.DividentNEFTFileReport.link}
                      element={
                        <Protected
                          permittedPages={"DividentNEFTFileReport"}
                          pageContext={context}
                        >
                          <DividentNEFTFileReport />
                        </Protected>
                      }
                    />
                    <Route
                      path={AllRoutes.HDFCToHDFCReport.link}
                      element={
                        <Protected
                          permittedPages={"HDFCToHDFCReport"}
                          pageContext={context}
                        >
                          <HDFCToHDFCReport />
                        </Protected>
                      }
                    />

                    <Route
                      path={AllRoutes.ShareRegisterReport.link}
                      element={
                        <Protected
                          permittedPages={"ShareRegisterReport"}
                          pageContext={context}
                        >
                          <ShareRegisterReport />
                        </Protected>
                      }
                    />

                    <Route
                      path={AllRoutes.DemandRecoveryDashboard.link}
                      element={
                        <Protected
                          permittedPages={"DemandRecoveryDashboard"}
                          pageContext={context}
                        >
                          <DemandRecoveryDashboard />
                        </Protected>
                      }
                      // element={<PaymentVerificationView />}
                    />
                    <Route
                      path="/DemandRecoveryForm"
                      element={<DemandRecoveryForm />}
                    />
                    <Route
                      path="/LoanSettlementPaymentDetails"
                      element={<PaymentDetails />}
                    />
                    <Route
                      path="/LoanSettlementDashboard"
                      element={<LoanSettlementDashboard />}
                    />
                    <Route
                      path="/LoanSettlementTabs"
                      element={<LoanSettlementTabs />}
                    />
                    {/* added by mahesh  */}
                    <Route
                      path="/FinalSettlement"
                      element={
                        <Protected
                          permittedPages={"FinalSettlement"}
                          pageContext={context}
                        >
                          <FinalSettlement />
                        </Protected>
                      }
                    />
                    <Route
                      path="/SettlementRequestTabs"
                      element={
                        <Protected
                          permittedPages={"SettlementRequestTabs"}
                          pageContext={context}
                        >
                          <SettlmentRequestTabs />
                        </Protected>
                      }
                    />
                    <Route
                      path="/SettlemetnPersonalDetails"
                      element={<StlmtPersonalDetails />}
                    />
                    <Route
                      path="/SettlementLoanDetails"
                      element={<StlmtLoanDetails />}
                    />
                    {/* end  */}
                    {/* <Route
                      path="/MonthlyCommonDashboard"
                      element={
                        <Protected
                          permittedPages={"MonthlyCommonDashboard"}
                          pageContext={context}
                        >
                          <MonthlyCommonDashboard />
                        </Protected>
                      }
                    /> */}
                    {/* </Routes> */}
                  </Routes>
                </div>
              </div>
            </div>
            {!headerArr.includes(window.location.pathname) &&
            context &&
            window.location.pathname !==
              AllRoutes.MemberRegistrationForm.link ? (
              <Sidebar menuOpen={menuOpen} />
            ) : null}
          </div>
        </>
        //     <Routes> <Route path={"*"} element={<AccessDenied />} /> </Routes>
      )}
      {(!headerArr.includes(window.location.pathname) && context) ||
      window.location.pathname === AllRoutes.MemberRegistrationForm.link ? (
        <Footer context={context} />
      ) : null}
    </div>
  );
};

export default Router;
